<ion-app>
  <ion-menu side="start" menuId="first" contentId="content1">
    <ion-header>
      <ion-toolbar class="menu-toolbar" color="tertiary" (click)="openPage('profile')">
        <ion-thumbnail [class.creator-highlight]="isCreator()">
          <img src="assets/img/appStoreIcon.png">
        </ion-thumbnail>
        <ion-title>{{'BAYADIC' | translate}}</ion-title>
        <div class="emailAccount">{{ userManager.user.email }}</div>
      </ion-toolbar>
    </ion-header>
    <ion-content class="menu-content">
      <ion-list class="menu-list">
        <ion-item ion-item side="left" [class.menu-item-active]="isActive('items')" (click)="openPage('items')">
          <ion-icon name="copy"></ion-icon>
          {{'TABS.myItems' | translate}}
        </ion-item>
        <ion-item ion-item side="left" [class.menu-item-active]="isActive('collections')" (click)="openPage('collections')">
          <ion-icon name="aperture"></ion-icon>
          <p>{{'TABS.collections' | translate}}</p>
        </ion-item>
        <!-- <ion-item ion-item side="left" (click)="openPage('friends')">
          <ion-icon name="people"></ion-icon>
          {{'TABS.friends' | translate}}
        </ion-item> -->
        <!-- <ion-item ion-item side="left" (click)="openPage('profile')">
          <ion-icon name="person" side="right"></ion-icon>
          {{'MENU.accountBtn' | translate}}
        </ion-item> -->
        <ion-item *ngIf="false" ion-item (click)="openPage('wallet')">
          <ion-icon name="star"></ion-icon>
          {{'MENU.credit' | translate}}
        </ion-item>
        <ion-item *ngIf="false" ion-item (click)="openPage('invite')">
          <ion-icon name="people"></ion-icon>
          {{'MENU.inviteFriends' | translate}}
        </ion-item>
        <!-- <ion-item *ngIf="isThemeNightMoode()" ion-item (click)="toggleNightMode()">
          <ion-icon name="color-palette"></ion-icon>
          {{'MENU.lightMode' | translate}}
        </ion-item> -->
        <!-- <ion-item *ngIf="!isThemeNightMoode()" ion-item (click)="toggleNightMode()">
          <ion-icon name="color-palette"></ion-icon>
          {{'MENU.nightMode' | translate}}
        </ion-item> -->
        <ion-item ion-item [class.menu-item-active]="isActive('settings')" (click)="openPage('settings')">
          <ion-icon name="settings"></ion-icon>
          {{'TITLE.settings' | translate}}
        </ion-item>
        <ion-item ion-item [class.menu-item-active]="isActive('support')" (click)="openPage('support')">
          <ion-icon name="logo-whatsapp"></ion-icon>
          {{'TITLE.support' | translate}}
        </ion-item>

      </ion-list>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="content1"></ion-router-outlet>
</ion-app>